package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw

// Style du conteneur de la grille des sections
val FormActionGridContainerStyle = CssStyle {
    base {
        Modifier.padding(left = 16.px)
    }
    Breakpoint.MD {
        Modifier.padding(left = 40.px)
    }
    Breakpoint.LG {
        Modifier.padding(left = 50.px)
    }
}

// Style du wrapper du bouton de soumission / téléchargement
val FormActionSubmitRowStyle = CssStyle {
    base {
        Modifier.padding(right = 16.px)
    }
    Breakpoint.MD {
        Modifier.padding(right = 40.px)
    }
    Breakpoint.LG {
        Modifier.padding(right = 50.px)
    }
}

// Style pour les boutons d'action (FormSubmitButton & DownloadCvButton)
val FormActionButtonStyle = CssStyle {
    base {
        Modifier
            .height(34.px)
            .padding(topBottom = 10.px, leftRight = 14.px)
            .fontSize(14.px)
    }
    Breakpoint.MD {
        Modifier
            .height(38.px)
            .padding(topBottom = 10.px, leftRight = 16.px)
            .fontSize(16.px)
    }
    Breakpoint.LG {
        Modifier
            .height(42.px)
            .padding(topBottom = 10.px, leftRight = 20.px)
            .fontSize(18.px)
    }
}

// Variantes compactes pour DownloadCvButton
val DownloadButtonCompactStyle = CssStyle {
    base {
        Modifier
            .height(32.px)
            .padding(topBottom = 6.px, leftRight = 12.px)
            .fontSize(12.px)
    }
}

val DownloadButtonIconGapStyle = CssStyle {
    base {
        Modifier.gap(0.px)
    }
    Breakpoint.MD {
        Modifier.gap(8.px)
    }
}

// Style pour la popup d'avertissement de validation
val ValidationPopupContainerStyle = CssStyle {
    base {
        Modifier
            .minWidth(240.px)
            .maxWidth(88.vw)
            .padding(topBottom = 12.px, leftRight = 14.px)
    }
    Breakpoint.MD {
        Modifier
            .minWidth(300.px)
            .maxWidth(380.px)
            .padding(topBottom = 16.px, leftRight = 18.px)
    }
}

val ValidationPopupHeaderGapStyle = CssStyle {
    base {
        Modifier.gap(10.px)
    }
    Breakpoint.MD {
        Modifier.gap(12.px)
    }
}

val ValidationPopupIconBoxStyle = CssStyle {
    base {
        Modifier.size(26.px)
    }
    Breakpoint.MD {
        Modifier.size(30.px)
    }
}

val ValidationPopupIconStyle = CssStyle {
    base {
        Modifier.size(14.px)
    }
    Breakpoint.MD {
        Modifier.size(16.px)
    }
}

val ValidationPopupTitleTextStyle = CssStyle {
    base {
        Modifier.fontSize(13.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(14.px)
    }
}

val ViewButtonStyle = CssStyle {
    base {
        Modifier
            .color(Colors.White)
            .backgroundColor(if (colorMode.isDark) Colors.LighterBlue else Colors.Blue)
    }
    hover {
        Modifier
            .color(Colors.White)
            .backgroundColor(if (colorMode.isDark) Colors.Blue else Colors.LighterBlue)
    }
}

val DownloadButtonMobileStyle = CssStyle {
    base {
        Modifier
            .height(34.px)
            .padding(
                topBottom = 10.px,
                leftRight = 14.px
            )
            .fontSize(14.px)
    }
}

val DownloadButtonDesktopStyle = CssStyle {
    base {
        Modifier
            .height(34.px)
            .padding(
                topBottom = 10.px,
                leftRight = 14.px
            )
            .fontSize(14.px)
    }

    Breakpoint.LG {
        Modifier
            .height(42.px)
            .padding(
                topBottom = 10.px,
                leftRight = 20.px
            )
            .fontSize(18.px)
    }
}

val DownloadButtonMobileWrapperStyle = CssStyle {
    base {
        Modifier.display(DisplayStyle.Block)
    }

    Breakpoint.LG {
        Modifier.display(DisplayStyle.None)
    }
}

val DownloadButtonDesktopWrapperStyle = CssStyle {
    base {
        Modifier.display(DisplayStyle.None)
    }

    Breakpoint.LG {
        Modifier.display(DisplayStyle.Block)
    }
}